import React from 'react';
import { useSelector } from 'react-redux';
import {
  SharedTemplateAboutModal,
  SharedTemplateDeleteModal,
  SharedTemplateDuplicateModal,
  SharedTemplateEditModal,
  SharedTemplateSaveModal,
  SharedTemplateShareModal,
  SharedTemplateUnsavedModal,
} from '../presentational/sharedTemplateComponents';

const VBTTemplateModals = () => {
  const vbtAboutModalShowing = useSelector(
    (state) => state.vbtDashboard.ui.aboutModalShowing,
  );
  const vbtDeleteModalShowing = useSelector(
    (state) => state.vbtDashboard.ui.deleteModalShowing,
  );
  const vbtDuplicateModalShowing = useSelector(
    (state) => state.vbtDashboard.ui.duplicateModalShowing,
  );
  const vbtEditModalShowing = useSelector(
    (state) => state.vbtDashboard.ui.editModalShowing,
  );
  const vbtSaveModalShowing = useSelector(
    (state) => state.vbtDashboard.ui.saveModalShowing,
  );
  const vbtShareModalShowing = useSelector(
    (state) => state.vbtDashboard.ui.shareModalShowing,
  );
  const unsavedVBTDashModalShowing = useSelector(
    (state) => state.vbtDashboard.ui.unsavedModalShowing,
  );

  return (
    <>
      {vbtAboutModalShowing && <SharedTemplateAboutModal dashboard='VBT' />}
      {vbtDeleteModalShowing && (
        <SharedTemplateDeleteModal dashboard='VBT' legacyName='VBT' />
      )}
      {vbtDuplicateModalShowing && (
        <SharedTemplateDuplicateModal dashboard='VBT' legacyName='VBT' />
      )}
      {vbtEditModalShowing && (
        <SharedTemplateEditModal dashboard='VBT' legacyName='VBT' />
      )}
      {vbtSaveModalShowing && (
        <SharedTemplateSaveModal dashboard='VBT' legacyName='VBT' />
      )}
      {vbtShareModalShowing && (
        <SharedTemplateShareModal dashboard='VBT' legacyName='VBT' />
      )}
      {unsavedVBTDashModalShowing && (
        <SharedTemplateUnsavedModal dashboard='VBT' legacyName='VBT' />
      )}
    </>
  );
};

export default VBTTemplateModals;
